import { getRootVue } from '../../common/baseMain'
import { getRouter } from '../../common/baseRouter'
import { getStore } from '../../common/baseStore'
import registFilter from './filter.js'
import Party from './Party.vue'
registFilter()
// get router config
const router = getRouter({
  routes: [
    {
      path: '/party',
      name: 'party',
      component: Party
    }
  ]
})
// get vue config
getRootVue({
  router
})
